import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import { useTranslation } from 'react-i18next';
import RequesterInfo from './RequesterInfo';
import UploadFiles from './UploadFiles';
import Modal from '../../../_ui/Modal/Modal';

export default function RequestInfoDialog({ row, open, onClose }) {
  const { t } = useTranslation();
  const info = row['_original'];
  return (
    <Modal open={open} onClose={onClose} title={t('attachChild_attachChild')}>
      <DialogContent className="disable">
        <RequesterInfo info={info} t={t} />
        <UploadFiles files={info?.supportingDocuments} />
      </DialogContent>
    </Modal>
  );
}
